import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyObject = Record<string, any>;

class ApiClient {
  client: AxiosInstance;

  host = window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host;


  constructor(basepath: string) {
    this.client = axios.create({
      baseURL: `https://${this.host}/api` + basepath,
      headers: {
        'Content-Type': 'application/json'
      },
      timeout:  20 * 60 * 1000
    });

    this.client.interceptors.request.use(this.requestInterceptor);
    this.client.interceptors.response.use(this.responseSuccessInterceptor, this.responseErrorInterceptor);
  }

  get(url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.get(url, config);
  }

  post(url: string, data: AnyObject, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.post(url, data, config);
  }

  put(url: string, data: AnyObject = {}, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.put(url, data, config);
  }

  patch(url: string, data: AnyObject = {}, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.patch(url, data, config);
  }

  delete(url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.delete(url, config);
  }

  options(url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.client.options(url, config);
  }

  generateAuthToken = async () => {
    const authSession = await fetchAuthSession({});
    const authToken = authSession.tokens?.idToken?.toString() as string;

    return authToken;
  };

  requestInterceptor = async (config: InternalAxiosRequestConfig) => {
    const authToken = await this.generateAuthToken();

    config.headers['Authorization'] = `Bearer ${authToken}`;

    return config;
  };

  responseSuccessInterceptor(response: AxiosResponse) {
    return response;
  }

  responseErrorInterceptor(error: AxiosError) {
    const requestOptions = error.config;
    const response = error.response;

    console.error(requestOptions, response);

    // if (response?.status === 400 && !requestOptions._retry) {
    //   console.debug('Auth token expired, regenerating....');
    //   requestOptions._retry = true;

    //   try {
    //     const authToken = await generateAuthToken();

    //     requestOptions.headers['Authorization'] = `Bearer ${authToken}`;

    //     return api(requestOptions);
    //   } catch (err) {
    //     return Promise.reject(err);
    //   }
    // }


    return Promise.reject(error);
  }
}

export default ApiClient;
